console.log('tet');
const btns = $('.our-team__nav-item')
btns.each(function () {
    const _this = $(this)
    _this.on('click', function () {
        btns.each(function (i, btn) {
            $(btn).removeClass('active')
        })
        _this.addClass('active')
        doAjaxQuery()
    })
})

function doAjaxQuery() {
    const category = $('.our-team__nav-item.active').attr('data-slug')
    const data = {
        'action': 'get_filter_team',
        'category': category,
    }
    

    $.ajax({
        url: myajax.url,
        data: data,
        type: 'POST',
        success: function (data) {
            const wrapper = $('.filter-news__swiper-wrapper')
            if (data) {
                $(".our-team__wrapper").html(data)
            } 
        },
    });
}